// This file is autogenerated. Any changes will be overwritten.

export const set = 'streamline';

export const name = 'rounded-large';

export const Component = () => (
  <g fill='none' stroke='transparent' strokeLinecap='round' strokeLinejoin='round'>
    <path fill='#D0E0F7' d='M2 12C2 6.649 6.649 2 12 2h6v16H2v-6Z' />
    <path
      fill='#4185DE'
      d='M1 12C1 5.92 5.92 1 12 1h6v2h-6c-5.075 0-9 3.925-9 9H1Zm17 6H1h17ZM1 18v-6C1 5.92 5.92 1 12 1v2c-5.075 0-9 3.925-9 9v6H1ZM18 3v15V3Z'
    />
  </g>
);

export const viewBox = '0 0 18 18';
